import { number, object, string } from "yup";
import { dayjs } from "@thalamos/common";
/**
 * A yup schema for a Form pushed to an External System.
 */
export const ExternalPatientFormPushEventSchema = object({
    id: string().uuid().required(),
    externalPatientLinkId: string().uuid().required(),
    formId: string().uuid().required(),
    formVersion: number().required(),
    created: string()
        .required()
        .transform((value) => dayjs(value).toISOString())
        .required(),
    filename: string().uuid().required(),
    title: string().uuid().required(),
    description: string().uuid().required(),
});
// We cannot use yup to infer as it doesn't work for tsoa.
// export type ExternalPatientFormPushEvent = InferType<typeof ExternalPatientFormPushEventSchema>;
// But we can use ObjectSchema<> to ensure they largely stay in sync
//# sourceMappingURL=externalPatientFormPushEvent.js.map